module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "card",
    on: {
      "click": function($event) {
        _vm.redirectTo(_vm.product.url)
      }
    }
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _vm._m(0, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-chevron-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7bf00da","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=os8u77dxteg!./~/string-replace-webpack-plugin/loader.js?id=zkc3fbyssup!./src/components/ecommerce/filter/Card.vue
// module id = 672
// module chunks = 0